<template>
  <div>
    <div class="field" :style="{marginTop: '30px'}">
      <div class="field">
        <div class="control">
          <label class="label">ວັນທີ ແລະ ເວລາໂອນ</label>
          <date-picker
              format="DD/MM/YYYY HH:mm"
              value-type="YYYY-MM-DD HH:mm:ss"
              type="datetime"
              v-model="paid_at"
              :clearable="false"
          ></date-picker>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">ໝາຍເຫດ</label>
          <input
              class="input"
              v-model="invoice_remark"
              placeholder="ໝາຍເຫດ..."
          >
        </div>
      </div>
    </div>
    <vs-button ref="button" flat
               @click="updateCodInvoiceStatus()"
               class="form-btn-loading"
               :loading="loading">
      ເເກ້ໄຂສະຖານະ
    </vs-button>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  components: {
    DatePicker,
  },
  props: [
    'invoiceIds',
  ],
  data: () => ({
    loading: false,
    invoice_remark: '',
    paid_at: '',
    statusOptions: [
      {value: 'pending', name: 'ກຳລັງດຳເນີນການ'},
      {value: 'success', name: 'ສຳເລັດ'},
    ],
    selectedStatus: {
      value: 'pending', name: 'ເລືອກທັງໝົດ'
    },
  }),
  created() {
    this.setDefaultPaidAt();
  },
  methods: {
    setDefaultPaidAt() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      this.paid_at = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    updateCodInvoiceStatus() {
      const invoiceIds = this.invoiceIds.map(item => item.id);
      this.loading = true;
      this.$http.post('admin/update-cod-balance-request-status', {
        invoices: invoiceIds,
        remark: this.invoice_remark,
        paid_at: this.paid_at,
      }).then((res) => {
        if (res.data.error === false){
          setTimeout(() => {
            this.loading = false;
            this.$emit('close');
            this.$emit('success');
            this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'primary', 3000);
          }, 200);
        }
      }).catch(() => {
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.button {
  &:hover {
    color: $white !important;
  }
}
</style>
